import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {goalView_template} from "../components/templates/goalView_template";

declare var ko: any;
declare var page: any;

export class goal_view extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected goalViewTemplate: goalView_template;

    protected getModuleName(){
        return "goal_view";
    }

    buildContent() : Array<Element>{
        this.goalViewTemplate = new goalView_template("goalViewTemplate", this.viewModel, this);

        return [this.goalViewTemplate.build()];
    }

    public backToList(): void{
        page.redirect('/goals');
    }

    public editGoal(goalId: number): void {
        page('/goals/edit/' + goalId);
    }

    //
    // fill the template page with data.
    fillPage() : void{
        this.getFormData();
    }
    //
    // getting data from server by ajax call.
    public getFormData(): void {

        this.loadingIn(this.goalViewTemplate.builtTemplate.children.namedItem("view-results"));
        let id: number;

        if( (id = this.getVnAppZone().app.params.id) && !isNaN(id)) {
            this.goalViewTemplate.getTemplateViewModel().idGoal(id);
        }

        let usrReq_url: string = '/api/goals/get/' + id + "/";
        let usrReq_params: Array<Array<string>> = [];

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetNetworkGroupDataReturn;
        this.XHRHdl.execute();
    }

    //
    // Handling response data
    protected onGetNetworkGroupDataReturn(req, obj): Function {

        return function () {
            obj.manageResponse(req, obj, function () {

                let response = JSON.parse(req.request.response);
                obj.setGoal(response);

                obj.loadingOut(obj.goalViewTemplate.builtTemplate.children.namedItem("view-results"));
            });
        }
    }
    //
    // set role on rolesView_template
    public setGoal(goal: any) : void {
        this.goalViewTemplate.setGoal(goal);
    }
}



// WEBPACK FOOTER //
// ./js/modules/goal_view.ts